import { FilterAlt } from "@mui/icons-material";
import useUIBp from "../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../store/slices/UI";
import ActionButton from "../../../UI/BasicLayout/Components/FilterPlusActions/ActionButton";

const UIText = {
  "es-CL": { label: "Columnas" },
  "en-US": { label: "Columnas" },
};

const ToggleColumns = () => {
  const { auth, dispatch, UI, warehouse, settings } = useUIBp();
  const { M365server, cloner_key } = auth;
  const locale = settings.locale;

  const onClick = () => {
    dispatch(
      UIactions.openModal({
        type: "toggle-report-columns",
        payload: {},
      }),
    );
  };

  return (
    <ActionButton
      {...{
        onClick,
        UIText,
        icon: <FilterAlt sx={{ fontSize: 18 }} />,
        variant: "outlined",
      }}
    />
  );
};

export default ToggleColumns;
